import React, {useEffect} from 'react';
import {TransformWidget} from './transform-widget';
import {state, tools} from '@app/state/utils';

export function TransformNav() {
  useEffect(() => {
    state().setDirty(true);
    tools().frame.active.hide();
    return () => {
      tools().frame.active.show();
    };
  }, []);

  return (
    <TransformWidget />
  );
}